import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
import { makeSelectTimesheetValue } from '../../../../../../../../../../services/timesheets/selectors';

interface Props {
    comment?: ?string;
}

export class TimesheetComment extends React.PureComponent<Props> {
    render() {
        const { comment } = this.props;
        if (!comment) return null;
        return comment;
    }
}

const mapStateToProps = createStructuredSelector({
    comment: makeSelectTimesheetValue('comment')
});

export default connect(mapStateToProps)(TimesheetComment);
